<template>
  <!-- 收藏统计 -->
  <div class="userGoods">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['数据分析', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="exportData"
          >导出数据</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">账号状态：</label>
        <el-select
          placeholder="账号状态"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option label="全部" value="99"></el-option>
          <el-option label="已审核" value="2"></el-option>
          <el-option label="未审核" value="1"></el-option>
        </el-select>
        <label class="label">证书状态：</label>
        <el-select
          placeholder="证书状态"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.type"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="正常" value="正常"></el-option>
          <el-option label="过期" value="过期"></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入关键字"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="userId"
        align="center"
        show-overflow-tooltip
        label="客户编号"
      >
      </el-table-column>
      <el-table-column
        prop="userName"
        align="center"
        show-overflow-tooltip
        label="客户名称"
      >
      </el-table-column>
      <el-table-column
        prop="erpCode"
        align="center"
        show-overflow-tooltip
        label="ERP编号"
      >
      </el-table-column>
      <el-table-column
        prop="businessName"
        align="center"
        show-overflow-tooltip
        label="单位名称"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        align="center"
        show-overflow-tooltip
        label="送货地址"
      >
      </el-table-column>
      <el-table-column
        prop="salezMan"
        align="center"
        show-overflow-tooltip
        label="销售员"
      >
      </el-table-column>
      <el-table-column
        prop="userType"
        align="center"
        show-overflow-tooltip
        label="企业分类"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        align="center"
        show-overflow-tooltip
        label="证书状态"
      >
      </el-table-column>
      <!-- <el-table-column
        prop="addressDate"
        align="center"
        show-overflow-tooltip
        label="送货日期">
      </el-table-column> -->
      <el-table-column
        prop="goodsId"
        align="center"
        show-overflow-tooltip
        label="商品编号"
      >
      </el-table-column>
      <el-table-column
        prop="goodsName"
        align="center"
        show-overflow-tooltip
        label="商品名称"
      >
      </el-table-column>
      <el-table-column
        prop="spec"
        align="center"
        show-overflow-tooltip
        label="商品规格"
      >
      </el-table-column>
      <el-table-column
        prop="factory"
        align="center"
        show-overflow-tooltip
        label="厂家/产地"
      >
      </el-table-column>
      <el-table-column
        prop="unit"
        align="center"
        show-overflow-tooltip
        label="商品单位"
      >
      </el-table-column>
      <el-table-column
        prop="stock"
        align="center"
        show-overflow-tooltip
        label="库存"
      >
      </el-table-column>
      <el-table-column
        prop="valdate"
        align="center"
        show-overflow-tooltip
        label="效期"
      >
      </el-table-column>
      <el-table-column
        prop="startDate"
        align="center"
        show-overflow-tooltip
        label="首次成交日期"
      >
      </el-table-column>
      <el-table-column
        prop="endDate"
        align="center"
        show-overflow-tooltip
        label="末次成交日期"
      >
      </el-table-column>
      <el-table-column
        prop="drainDate"
        align="center"
        show-overflow-tooltip
        label="流失天数"
      >
      </el-table-column>
      <el-table-column
        prop="buyGoods"
        align="center"
        show-overflow-tooltip
        label="采购频次"
      >
      </el-table-column>
      <el-table-column
        prop="buyDate"
        align="center"
        show-overflow-tooltip
        label="采购周期"
      >
      </el-table-column>
      <el-table-column
        prop="buyNextDate"
        align="center"
        show-overflow-tooltip
        label="预计下次采购日期"
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "userGoods",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**搜索表单 */
      searchForm: {
        status: "99",
        type: "",
        name: "",
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "CustomerGoods",
        strWhere: this.searchForm.name,
        accountStatus: this.searchForm.status,
        certificateStatus: this.searchForm.type,
        ABCType: "",
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Statistical"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          this.tableData = [];
          this.allPage = 0;
          if (res.flag == 0) {
            this.allPage = res.recordCount;
            this.tableData = res.data.map((item) => ({
              userId: item.userid, // 客户编号
              userName: item.username, // 客户名称
              erpCode: item.erp_dwbh, // ERP编号
              businessName: item.businessname, // 单位名称
              address: item.shouhdz, // 送货地址
              salezMan: item.salezMan, // 销售员
              userType: item.clienttype, // 企业分类
              status: item.CredentialStatus, // 证书状态
              addressDate: item.DeliveryDate, // 送货日期
              goodsId: item.erp_spid, // 商品编号
              goodsName: item.sub_title, // 商品名称
              spec: item.drug_spec, // 商品规格
              factory: item.drug_factory, // 厂家/产地
              unit: item.package_unit, // 商品单位
              stock: item.stock_quantity, // 库存
              valdate: item.valdate, // 效期
              startDate: item.FirstSaleDate, // 首次成交日期
              endDate: item.LastSaleDate, // 末次成交日期
              drainDate: item.lsts, // 流失天数
              buyGoods: item.cgpc, // 采购频次
              buyDate: item.cgzq, // 采购周期
              buyNextDate: item.NextSaleDate, // 预计下次采购日期
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    exportData() {
      let data = {
        type: "CustomerGoods",
        userId: window.localStorage.getItem("userId"),
        entId: window.localStorage.getItem("entId"),
        strWhere: this.searchForm.name,
        accountStatus: this.searchForm.status,
        certificateStatus: this.searchForm.type,
        ABCType: "",
        PageIndex: 1,
        PageSize: 9999999,
      };
      let proc = "Proc_Admin_Statistical"; // 存储过程名
      window.location.href =
        this.baseUrl +
        "Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name=客户商品";
    },
  },
};
</script>

<style scoped>
.userGoods {
  width: 100%;
  height: 100%;
}
</style>
